import React from "react";
import { useContext } from "react";
import { ModalContext } from "components/ModalContext";
import "./hubContact.scss";

import SupportModal from "components/modals/SupportModal";
import UniversalButton from "components/uiComponents/UniversalButton";

import { ReactComponent as CloseIcon } from 'static/icons/close.svg';

const HubContactButton = ({
  onHideHelp,
}) => {
  const { handleModal } = useContext(ModalContext);

  const handleCloseModal = () => {
    handleModal(null, true);
  };

  const handleClick = () => {
    handleModal(
      <SupportModal closeModal={handleCloseModal} />,
      false,
      true
    );
  };

  return (
    <div className="hub-contact-btn">
      <p>Do you have a problem?</p>

      <UniversalButton
        label="Contact support"
        size="lg"
        labelColor="white"
        labelHoverColor="white"
        backgroundColor="orange"
        backgroundHoverColor="orange-light"
        isFullWidth
        onClick={handleClick}
      />

      <button
        className="hub-contact-btn__close"
        onClick={onHideHelp}
      >
        <CloseIcon className="hub-contact-btn__close_icon" />
      </button>
    </div>
  );
};

export default HubContactButton;
